import { render, staticRenderFns } from "./TabelaMes.vue?vue&type=template&id=6380e64a"
import script from "./TabelaMes.vue?vue&type=script&lang=js"
export * from "./TabelaMes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports